const ExceptionsTypes = {
  NotFound: {
    status: 404,
  },
  BadRequest: {
    status: 400,
  },
  Success: {
    status: 200,
  },
  UnExpected: {
    status: 500,
  },
};
function createException(type, message, error = {}) {
  throw new Error({ ...type, message, error });
}
export { ExceptionsTypes, createException };
